import React, { Component } from 'react'
import EntityList from './../../components/entityList';

class Wheels extends Component {
  render() {
    return (
      <EntityList apiRoute='api/wheels' title='Remorque - Pneus' editTitle='Pneus' displayColumns={[
        {Description: 'Description', Column: 'Description'},
        {Description: 'Inactif', Column: 'Inactive', sortable: false, format: {type: 'boolean'}}
      ]}/>
    )
  }
}

export default Wheels;


/** WEBPACK FOOTER **
 ** ./src/app/routes/trailers/wheels.js
 **/